import { useAtomValue } from 'jotai';
import { downloadBannerShowAtom } from '@/store';
import { showAppDownloadBanner } from '@/utils/tools';

/**
 * Check if app download banner should be shown
 * @returns true if banner should be shown, false otherwise
 */
export function useShowAppBanner(): boolean {
  const isShowDownloadBanner = useAtomValue(downloadBannerShowAtom);
  return showAppDownloadBanner() && isShowDownloadBanner && !window?.sessionStorage?.getItem('app-banner-hide');
}
